<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar nova construção"
             col-md="col-md-6" offset="3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-3">
            <button type="button" @click="abrirModal()" class="btn btn-primary">
              <i class="fa fa-plus"></i> Importar modelo
            </button>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="modelo.descricao" size="small" style="width: 100%" disabled/>
                <label for="descricao"><strong>Modelo: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descritivo" v-model="modelo.descritivo" size="small" style="width: 100%" disabled/>
                <label for="descritivo"><strong>Descritivo: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.imovel"
                    inputId="imovel"
                    :options="imoveis"
                    optionLabel="descricao"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('imovel')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="imovel">
                  <strong>Imóvel:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicio" dateFormat="dd/mm/yyyy"
                            @update:modelValue="atualizarDataPrevisao"
                            :invalid="campoVazio.includes('data_inicio')"/>
                <label for="data_inicio">
                  <strong>Data de Inicio: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="tempo_construcao" v-model="dado.tempo_construcao" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }" @update:modelValue="atualizarDataPrevisao"
                             :invalid="campoVazio.includes('tempo_construcao')"/>
                <label for="tempo_construcao"><strong>Tempo Construção: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino_previsao" v-model="dado.data_termino_previsao" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTerminoPrevisao" disabled
                            dateFormat="dd/mm/yyyy"/>
                <label for="data_termino_previsao"><strong>Previsão Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino" v-model="dado.data_termino" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTermino" dateFormat="dd/mm/yyyy"/>
                <label for="data_termino"><strong>Data de Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="previsao_orcamentaria" v-model="dado.previsao_orcamentaria" size="small"
                             style="width: 100%" :invalid="campoVazio.includes('previsao_orcamentaria')"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="previsao_orcamentaria">
                  <strong>Previsão Orçamentária: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
  <ImportarModelo
      v-if="importarModelo"
      :idModal="'importarModelo'"
      @modeloSelecionado="preencherModelo"
      @fecharSubModal="importarModelo = false"
  />
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import ImportarModelo from "@/views/construcoes/ImportarModelo.vue";
import moment from 'moment';
import {apiRequest, calculoDataPrevisao, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarConstrucoes",
  components: {
    ImportarModelo,
    BaseModal,
  },
  emits: ["fechar", "atualizarLista"],
  data() {
    return {
      imoveis: [],
      dado: {
        imovel: "",
        data_inicio: null,
        tempo_construcao: "",
        data_termino_previsao: null,
        data_termino: null,
        previsao_orcamentaria: "",
        modelo: "",
      },
      modelo: {
        descricao: "",
        descritivo: "",
      },
      importarModelo: false,
      campoVazio: [],
    }
  },
  methods: {
    abrirModal() {
      this.importarModelo = true;
    },
    async getImoveis() {
      const resultado = await apiRequest("GET", `${apiUrl.imoveis.createList}?status=D`);
      if (resultado.success) {
        this.imoveis = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    preencherModelo(modelo) {
      this.dado.modelo = modelo.id;
      this.dado.previsao_orcamentaria = parseFloat(modelo.orcamento);
      this.modelo.descricao = modelo.descricao;
      this.modelo.descritivo = modelo.descritivo;
    },
    atualizarDataPrevisao() {
      const {data_inicio, tempo_construcao} = this.dado;
      if (data_inicio && tempo_construcao !== "") {
        this.dado.data_termino_previsao = calculoDataPrevisao(data_inicio, tempo_construcao).replaceAll('/', '-');
      } else {
        this.dado.data_termino_previsao = null;
      }
    },
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_termino', 'data_termino_previsao']);
      const resultado = await apiRequest("POST", apiUrl.construcoes.createList, this.dado);
      if (resultado.success) {
        ['data_inicio', 'data_termino', 'data_termino_previsao'].forEach(field => {
          if (resultado.data[field] != null) {
            resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY')
          }
        });
        this.$emit("atualizarLista", resultado.data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getImoveis();
    Inputmask("99/99/9999").mask(this.$refs.dataInicio.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTermino.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTerminoPrevisao.$el.querySelector("input"));
  },
}
</script>
